export default function HtmlUnsafe($sce) {
    'ngInject';
    return $sce.trustAsHtml;
}



// WEBPACK FOOTER //
// ./src/app/filters/htmlUnsafe.filter.js